export default {
  state: {
    title: 'Estado',
    visible: 'Pedidos en mesa visibles',
    on: 'Pedidos en mesa',
  },
  notes: {
    hidden: {
      title: 'El pedido en mesa está oculto',
      description:
        'Está activado, pero tu tienda no lo muestra, así que se rechaza todo pedido en mesa. Activa «Pedido en mesa visible» para mostrarlo.',
      link: 'Ir al interruptor',
    },
    off: {
      title: 'Ahora los clientes no pueden pedir en la mesa',
      description:
        'Activa ambos interruptores para empezar. Hasta entonces, el código QR de una mesa abre tu tienda con Recogida y Entrega.',
    },
    no_active_table: {
      title: 'Aún los clientes no pueden pedir en la mesa',
      description: 'Añade una mesa abajo y actívala.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
};
